import { Pipe, PipeTransform } from '@angular/core';
import {BarcodeStatus} from '../domain/accounts/IBarcode';

@Pipe({
  name: 'filterBarcodeStatus'
})
export class FilterBarcodeStatusPipe implements PipeTransform {

  transform(status: string): string {
    switch (status) {
      case BarcodeStatus.NEW:
        return $localize`:@@barcodesNew:Nuevo`;

      case BarcodeStatus.CANCELLED:
        return $localize`:@@barcodesCancelled:Cancelado`;

      case BarcodeStatus.CONSUMED:
        return $localize`:@@barcodesConsumed:Utilizado`;

      case BarcodeStatus.EXPIRED:
        return $localize`:@@barcodesExpired:Expirado`;

      case BarcodeStatus.PENDING:
        return $localize`:@@barcodesPending:Pendiente`;

      case BarcodeStatus.DECLINED:
        return $localize`:@@barcodesDeclined:Declinado`;

      default:
        return status.toString();
    }
  }

}
